import { createReducer, on } from '@ngrx/store';
import { dailyActivityActions } from './activity.action';
import { dailyActivityState } from './activity.state';

export const dailyActivityReducer = createReducer(
  dailyActivityState,

  // --- Activities ---
  on(dailyActivityActions.fetchActivities, (state) => ({
    ...state,
    loading: { ...state.loading, activity: true },
    error: { ...state.error, activity: null }
  })),
  on(dailyActivityActions.fetchActivitiesSuccess, (state, { activities }) => ({
    ...state,
    activities,
    loading: { ...state.loading, activity: false }
  })),
  on(dailyActivityActions.fetchActivitiesFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, activity: false },
    error: { ...state.error, activity: error }
  })),
  on(dailyActivityActions.setFitnessActivity, (state, { fitnessActivity }) => ({
    ...state,
    fitnessActivity
  })),

  // --- Categories ---
  on(dailyActivityActions.fetchCategories, (state) => ({
    ...state,
    loading: { ...state.loading, category: true },
    error: { ...state.error, category: null }
  })),
  on(dailyActivityActions.fetchCategoriesSuccess, (state, { categories }) => ({
    ...state,
    categories,
    // selectedCategory: categories.length > 0 ? categories[0] : null,
    selectedCategory: null,
    loading: { ...state.loading, category: false }
  })),
  on(dailyActivityActions.fetchCategoriesFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, category: false },
    error: { ...state.error, category: error }
  })),

  // --- User Activities ---
  on(dailyActivityActions.fetchUserActivities, (state) => ({
    ...state,
    loading: { ...state.loading, userActivity: true },
    error: { ...state.error, userActivity: null }
  })),
  on(
    dailyActivityActions.fetchUserActivitiesSuccess,
    (state, { userActivities }) => ({
      ...state,
      userActivities,
      loading: { ...state.loading, userActivity: false }
    })
  ),
  on(dailyActivityActions.fetchUserActivitiesFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, userActivity: false },
    error: { ...state.error, userActivity: error }
  })),

  // --- Selected Category ---
  on(
    dailyActivityActions.setSelectedCategory,
    (state, { selectedCategory }) => ({
      ...state,
      selectedCategory
    })
  ),

  // --- Search ---
  on(dailyActivityActions.setSearchKeyword, (state, { keyword }) => ({
    ...state,
    searchKeyword: keyword
  })),

  // --- Save User Activity
  on(dailyActivityActions.saveUserActivity, (state) => ({
    ...state,
    loading: { ...state.loading, userActivity: true },
    error: { ...state.error, userActivity: null }
  })),
  on(dailyActivityActions.saveUserActivitySuccess, (state) => ({
    ...state,
    loading: { ...state.loading, userActivity: true },
    error: { ...state.error, userActivity: null }
  })),
  on(dailyActivityActions.saveUserActivityFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, userActivity: false },
    error
  })),

  // --- Update User Activity
  on(dailyActivityActions.updateUserActivity, (state) => ({
    ...state,
    loading: { ...state.loading, userActivity: true },
    error: { ...state.error, userActivity: null }
  })),
  on(dailyActivityActions.updateUserActivitySuccess, (state) => ({
    ...state,
    loading: { ...state.loading, userActivity: true },
    error: { ...state.error, userActivity: null }
  })),
  on(dailyActivityActions.updateUserActivityFailure, (state, { error }) => ({
    ...state,
    loading: { ...state.loading, userActivity: false },
    error
  }))
);
